import { initFancybox } from "./fancybox";
import { activeGoogleMaps } from './google-maps';
import { activeGoogleMapsMultipleMarkers } from './google-maps-marker';

const windowAny = window as any;

function openLocationPopup(locationId: string | number) {
  const trigger = document.querySelector<HTMLElement>(`.locations-table-trigger[data-location-id="${locationId}"]`);
  trigger?.click();
}

function initRowClicks() {
  document.querySelectorAll<HTMLElement>(".locations-table-row").forEach((row) => {
    const open = () => {
      const trigger = row.querySelector<HTMLElement>(".locations-table-trigger");
      trigger?.click();
    };

    row.addEventListener("click", (event) => {
      const target = event.target as HTMLElement | null;
      if (target?.closest("a[href], button")) return;
      open();
    });

    row.addEventListener("keydown", (event) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      open();
    });
  });
}

windowAny.appLocations = windowAny.appLocations || {};
windowAny.appLocations.activeGoogleMaps = windowAny.appLocations.activeGoogleMaps || activeGoogleMaps;
windowAny.appLocations.activeGoogleMapsMultipleMarkers = windowAny.appLocations.activeGoogleMapsMultipleMarkers || activeGoogleMapsMultipleMarkers;
windowAny.appLocations.initFancybox = windowAny.appLocations.initFancybox || initFancybox;
windowAny.appLocations.initRowClicks = windowAny.appLocations.initRowClicks || initRowClicks;
windowAny.appLocations.openLocationPopup = windowAny.appLocations.openLocationPopup || openLocationPopup;